import { render, staticRenderFns } from "./Intro_Index.vue?vue&type=template&id=23d1f57c&"
import script from "./Intro_Index.vue?vue&type=script&lang=js&"
export * from "./Intro_Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports